import { formatCalendarDate } from "./date.utils";

export type ReportStatus = 'draft' | 'generating' | 'ready' | 'submitted' | 'failed';


export function formatReportDate(dateString: string | null | undefined): string {
    return formatCalendarDate(dateString);
}

export function formatReportDateRange(startDate: string | null | undefined, endDate: string | null | undefined): string {
    if (!startDate && !endDate) return 'All time';
    const start = formatCalendarDate(startDate);
    const end = formatCalendarDate(endDate);
    return `${start} - ${end}`;
}

export function formatReportTimestamp(timestamp: number | undefined): string {
    if (!timestamp) return '-';
    return new Date(timestamp).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

export function getOrganizationName(organizationId: string, organizations: { id: string; name: string }[]): string {
    const org = organizations.find(o => o.id === organizationId);
    return org?.name || organizationId;
}

export function getReportStatusLabel(status: ReportStatus): string {
    switch (status) {
        case 'draft': return 'Draft';
        case 'generating': return 'Generating';
        case 'ready': return 'Ready';
        case 'submitted': return 'Submitted';
        case 'failed': return 'Failed';
        default: return status;
    }
}


export function getReportStatusIcon(status: ReportStatus): string {
    switch (status) {
      case 'draft': return 'bi-pencil';
      case 'generating': return 'bi-hourglass-split';
      case 'ready': return 'bi-check-circle';
      case 'submitted': return 'bi-send-check';
      case 'failed': return 'bi-exclamation-circle';
      default: return 'bi-circle';
    }
}

export function getReportStatusClass(status: ReportStatus): string {
    switch (status) {
      case 'draft': return 'bg-secondary';
      case 'generating': return 'bg-info';
      case 'ready': return 'bg-success';
      case 'submitted': return 'bg-primary';
      case 'failed': return 'bg-danger';
      default: return 'bg-secondary';
    }
}